<template>
  <div>

    <HeroSection />
      <PropertyAiExplanation />
    <AboutUsSection />
    <ServicesSection />
    <OurWorkProcessSection />
    <PromoSection />
    <OurWorkOrPortfolioSection />
    <!-- <PromoSectionTwo /> -->
    <!-- <TeamTwoSection />
    <TestimonialSection />
    <BlogSection /> -->
    <CallToActionSection />

  </div>
</template>

<script setup>
import HeroSection from '../pages/home/HeroSection.vue'
import AboutUsSection from '../pages/home/AboutUsSection.vue'
import ServicesSection from '../pages/home/ServicesSection.vue'
import OurWorkProcessSection from '../pages/home/OurWorkProcessSection.vue'
import PromoSection from '../pages/home/PromoSection.vue'
import OurWorkOrPortfolioSection from '../pages/home/OurWorkOrPortfolioSection.vue'
import PromoSectionTwo from '../pages/home/PromoSectionTwo.vue'
import TeamTwoSection from '../pages/home/TeamTwoSection.vue'
import TestimonialSection from '../pages/home/TestimonialSection.vue'
import BlogSection from '../pages/home/BlogSection.vue'
import CallToActionSection from '../pages/home/CallToActionSection.vue'
import PropertyAiExplanation from '../pages/property_detail/PropertyAiExplanation.vue'

</script>
